import script from "./item2.vue?vue&type=script&setup=true&lang=js"
export * from "./item2.vue?vue&type=script&setup=true&lang=js"

import "./item2.vue?vue&type=style&index=0&id=4747d9cc&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4747d9cc"]])

export default __exports__